import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { NavDataType } from "./common";
import { PROVIDER_PATHS, appPaths } from "./paths";
import LogoutIcon from "@mui/icons-material/Logout";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";

export const ADMIN_MENU: NavDataType[] = [
  { label: "Dashboard", path: appPaths.dashboardPath, value: "dashboard" },
  {
    label: "Provider Groups",
    path: appPaths.providerGroupsPath,
    value: "provider_groups",
  },
  {
    label: "Library",
    value: "library",
    children: [
      {
        label: "Data Import",
        path: appPaths.libraryPath,
        value: "dataImport",
      },
      {
        label: "Catalog",
        path: appPaths.libraryCatalogPath,
        value: "catalog",
      },
      // {
      //   label: "Form Builder",
      //   path: appPaths.libraryFormBuilderPath,
      //   value: "formBuilder",
      // },
      {
        label: "Templates",
        path: appPaths.libraryTemplatesPath,
        value: "templates",
      },
    ],
  },
  {
    label: "Settings",
    value: "settings",
    children: [
      {
        label: "Profile",
        path: appPaths.settings,
        value: "profile",
      },
      // todo: temporary hide audit log as per Provided Requirement
      // {
      //   label: "Audit Log",
      //   path: appPaths.settingsAuditLog,
      //   value: "audit_log",
      // },
      {
        label: "Roles & Responsibility",
        path: appPaths.tenantSettingsRolesAndResponsibility,
        value: "roles_and_responsibility",
      },
    ],
  },
  // todo: temporary hide tenant setting as per Provided Requirement
  // {
  //   label: "Tenant Settings",
  //   value: "tenantSettings",
  //   children: [
  //     {
  //       label: "Tenant Providers",
  //       path: appPaths.tenantSettings,
  //       value: "tenant_providers",
  //     },
  //     {
  //       label: "Admin Users",
  //       path: appPaths.tenantSettingsAdminUsers,
  //       value: "admin_users",
  //     },
  //     {
  //       label: "Tenant Configuration",
  //       path: appPaths.tenantSettingsTenantConfiguration,
  //       value: "tenant_configuration",
  //     },
  //     {
  //       label: "Roles & Permissions",
  //       path: appPaths.tenantSettingsRolesAndResponsibility,
  //       value: "roles_and_responsibility",
  //     },
  //   ],
  // },
];

export const NAV_PROFILE_ACTION = {
  HELP: "help",
  PROFILE: "profile",
  LOG_OUT: "log_out",
} as const;

export const NAVBAR_PROFILE_OPTIONS: NavDataType[] = [
  {
    label: "Help",
    // path: appPaths.help,
    value: NAV_PROFILE_ACTION.HELP,
    icon: HelpOutlineOutlinedIcon,
  },
  {
    label: "Profile",
    path: appPaths.settings,
    value: NAV_PROFILE_ACTION.PROFILE,
    icon: PersonOutlineOutlinedIcon,
  },
  {
    label: "Sign Out",
    // path: appPaths.logout,
    value: NAV_PROFILE_ACTION.LOG_OUT,
    icon: LogoutIcon,
  },
];

export const PROVIDER_NAV_OPTIONS: NavDataType[] = [
  {
    label: "Help",
    // path: appPaths.help,
    value: NAV_PROFILE_ACTION.HELP,
    icon: HelpOutlineOutlinedIcon,
  },
  {
    label: "Profile",
    path: PROVIDER_PATHS.ACCOUNT_SETTINGS,
    value: NAV_PROFILE_ACTION.PROFILE,
    icon: PersonOutlineOutlinedIcon,
  },
  {
    label: "Sign Out",
    // path: appPaths.logout,
    value: NAV_PROFILE_ACTION.LOG_OUT,
    icon: LogoutIcon,
  },
];
